import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { blogCategoryService, BlogCategory } from '@/services/other-services'
import { toast } from 'sonner'

export function useBlogCategories(params?: { all?: boolean; lang?: string }) {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['blog-categories', params],
        queryFn: () => blogCategoryService.getAll(params),
    })

    const createMutation = useMutation({
        mutationFn: blogCategoryService.create,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-categories'] })
            toast.success('Yeni blog kategorisi oluşturuldu')
        },
        onError: () => toast.error('Kategori oluşturulurken bir hata oluştu'),
    })

    const updateMutation = useMutation({
        mutationFn: ({ id, data }: { id: string; data: Partial<BlogCategory> }) =>
            blogCategoryService.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-categories'] })
            toast.success('Kategori güncellendi')
        },
        onError: () => toast.error('Güncelleme sırasında bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: blogCategoryService.delete,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-categories'] })
            toast.success('Kategori silindi')
        },
        onError: () => toast.error('Silme işlemi sırasında bir hata oluştu'),
    })

    return {
        ...query,
        createCategory: createMutation.mutateAsync,
        updateCategory: updateMutation.mutateAsync,
        deleteCategory: deleteMutation.mutateAsync,
        isMutating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
    }
}
